module.exports = __webpack_public_path__ + "resources/img-error.5e62cc42656ec887.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-error/img/img-error.png
// module id = 510
// module chunks = 0 1 2 3 4